import React, {useState} from 'react';
import cn from 'classnames';

import {flattenArray} from 'coreUtils/utils';

import {AccordionGroupContext} from './context/AccordionGroupContext';
import {EAccordionGroupStyle, IAccordionGroupProps} from './IAccordionGroup';

import styles from './AccordionGroup.module.scss';

const THEMES_MAP = {
	[EAccordionGroupStyle.Contrast]: {
		expandIcon: 'caret-down-fill',
		collapseIcon: 'caret-down-fill',
	},
	[EAccordionGroupStyle.AnimatedCaret]: {
		expandIcon: 'caret-down-fill',
		collapseIcon: 'caret-down-outline',
	},
};

const AccordionGroup = (props: IAccordionGroupProps) => {
	const {hTag, children = [], activeIndex = [], classNames, allowMultipleOpen} = props;
	const [activeAccordionItemIndexes, setActiveAccordionItemIndexes] = useState([activeIndex]);

	const handleAccordionTitleClick = (index: number) => {
		if (allowMultipleOpen) {
			const newActiveAccordionItem = activeAccordionItemIndexes.includes(index)
				? activeAccordionItemIndexes.filter((item) => item !== index)
				: [...activeAccordionItemIndexes, index];

			setActiveAccordionItemIndexes(newActiveAccordionItem);
		} else {
			if (activeAccordionItemIndexes.includes(index)) {
				setActiveAccordionItemIndexes([]);
			} else {
				setActiveAccordionItemIndexes([index]);
			}
		}
	};

	let expandIcon: string = 'minus';
	let collapseIcon: string = 'plus';

	if (typeof THEMES_MAP[props?.style] !== 'undefined') {
		expandIcon = THEMES_MAP[props?.style].expandIcon;
		collapseIcon = THEMES_MAP[props?.style].collapseIcon;
	}

	return (
		<div className={cn('accordion_group', classNames, styles['accordion_group'])} data-type={props?.style}>
			{React.Children.toArray(children).length &&
				flattenArray(children).map((content, arrayKey) => {
					const key = content?.props?.id ? content.props.id : arrayKey;

					return (
						<AccordionGroupContext
							key={`accordion-${key}`}
							value={{
								hTag,
								handleClick: () => handleAccordionTitleClick(key),
								isActive: activeAccordionItemIndexes.includes(key),
								expandIcon,
								collapseIcon,
							}}
						>
							{content}
						</AccordionGroupContext>
					);
				})}
		</div>
	);
};

export default AccordionGroup;
